import { useDispatch, useSelector } from "react-redux";
import useCreditoFiscal from "../../../actions/credito-fiscal.actions";
import { ModalBase } from "../../../components/Modals/ModalBase";
import BasicCardDocumentos from "./BasicCardDocumentos";
import { State } from "../../../reducers";
import { useEffect, useMemo, useState } from "react";
import InputForm from "./InputFormV2";
import { CFFormClienteFeles } from "../../../interfaces/credito-fiscal.interfaces";
import { generalOpenModalError } from "../../../actions/general.actions";
import { KEYS } from "../../../constants/keysStorage";

export default function ModalAsociaClienteFeles (){
    const {modal_button_cerrarClienteFeles, onChangeFormClienteFeles, setErrorsFormClienteFeles} = useCreditoFiscal()
    const dispatch = useDispatch();

    const {formClienteFeles, errorsClienteFeles} = useSelector((state: State) => state.creditoFiscal)
    const {tipoCargosMembresia, bancos} = useSelector((state: State) => state.catalogos)
    
    const handleChangeFormCliente = (e: any) => {
      switch (e.target.name) {
        case 'documento':
          onChangeFormClienteFeles(e.target.name, e.target.value);
          onChangeComprobante(e);
          break;
        
        case 'valorTransaccion':
          if (formClienteFeles.tipoTransaccion === '02' && e.target.value?.length <= 2) {
            onChangeFormClienteFeles(e.target.name, e.target.value);
          }
          else if (formClienteFeles.tipoTransaccion === '01' && e.target.value?.length <= 20) {
            onChangeFormClienteFeles(e.target.name, e.target.value);
          }
          break;

        case 'numAutorizacion':
          if (e.target.value?.length <= 30) {
            onChangeFormClienteFeles(e.target.name, e.target.value);
          }
          break;

        default:
          onChangeFormClienteFeles(e.target.name, e.target.value);
          break;
      }
    }

    const onChangeComprobante = (e: any) => {
      try {
          const selectedFile = e.target.files[0]
          if(selectedFile) {
              const reader = new FileReader();
              reader.onload = () => {
                const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf('.'));
                const validTypes = ['.pdf']
                
                // Validar tamaño
                if (selectedFile.size > 2097152) { // 2MB en bytes
                  setErrorsFormClienteFeles({
                    documento: 'El tamaño del comprobante debe ser menor o igual a 2MB.'
                  });
                  return;
                }

                if(!validTypes.includes(fileExtension.toLowerCase())){
                  setErrorsFormClienteFeles({
                    documento: 'Por favor, selecciona un archivo con una extensión válida. (.pdf)'
                  });
                  return;
                }

                setErrorsFormClienteFeles({ documento: '' })
              }

              reader.onloadend = () => {
                if(typeof reader.result === 'string'){
                  const base64file = reader.result.split(',')[1];
                  localStorage.setItem(KEYS.COMPROBANTE, base64file);
                }
              }
              reader.readAsDataURL(selectedFile)
          } else {
            localStorage.setItem(KEYS.COMPROBANTE, '');
          }
      } catch (error) {
        dispatch(generalOpenModalError('Ocurrió un error al procesar el comprobante, intenta cargarlo nuevamente.'))
      }
    }

    const labelInputCargo = useMemo(() => {
      switch (formClienteFeles.tipoTransaccion) {
        case '01':
          return 'No. Recibo'
        case '02':
          return 'No. Cuotas'
        default:
          return '';
      }
    }, [formClienteFeles.tipoTransaccion])

    const validateForm = (name: string, value: any) => {
      let message = ''

      switch(name){
        case 'tipoTransaccion':
          if(!value) message = 'El tipo de transacción es requerido'
          break;

        case 'valorTransaccion':
          if (formClienteFeles.tipoTransaccion === '01' || formClienteFeles.tipoTransaccion === '02') {
            if(!value) message = 'Valor requerido';
          }
          break;

        case 'documento':
          if (formClienteFeles.tipoTransaccion === '02') {
            if(!localStorage.getItem(KEYS.COMPROBANTE)) message = 'Comprobante requerido';
          }
          break;

        case 'numAutorizacion':
          if (formClienteFeles.tipoTransaccion === '02') {
            if(!value) message = 'Número de autorización requerido';
          }
          break;

        case 'idBanco':
          if (formClienteFeles.tipoTransaccion === '02') {
            if(!value) message = 'Banco requerido';
          }
          break;

        default:
          break;
      }

      return message;
    }

    const validFormFeles = useMemo(() => {
      var disableBtn = false;
      for (const key of Object.keys(formClienteFeles) as Array<keyof CFFormClienteFeles>) {
        const value = formClienteFeles[key]; 
        const validacionMsg = validateForm(key, value);

        if (validacionMsg !== "") {
          disableBtn = true;
        }
      }

      return disableBtn;
    }, [formClienteFeles, errorsClienteFeles]);

    return (
      <ModalBase>
        <BasicCardDocumentos title="Asociar cliente feles">  
          <div className="tab-plane">
            <div className='w-layout-hflex h-inputs'>
              <InputForm 
                required 
                keyNameText = 'codigo_nombre' 
                keyNameValue = 'codigo' 
                name = 'tipoMembresia' 
                placeholder = 'Tipo de transacción' 
                label = 'Tipo de transacción' 
                type = 'select' 
                value = {formClienteFeles?.tipoTransaccion} 
                maxMenuHeight = {100}
                defaultValue={"00"}
                onChange = {(e: any) => onChangeFormClienteFeles('tipoTransaccion', e.value)}
                options = {[
                  { codigo: '00', codigo_nombre: 'Sin asociar'}, 
                  ...tipoCargosMembresia?.filter((tme) => tme.codigo === "01")?.map((tm) => ({...tm, codigo_nombre: `${tm?.valor}`}))
                ]}
              />
              {/* Mostrar input si no es asociacion o cargo extraordinario */}
              {
                (formClienteFeles.tipoTransaccion !== '00' && formClienteFeles.tipoTransaccion !== '03') 
                  &&
                  <InputForm 
                    maxLength = {3}
                    required 
                    name = 'valorTransaccion' 
                    placeholder = {labelInputCargo} 
                    label = {labelInputCargo}
                    type = 'number' 
                    value = {formClienteFeles?.valorTransaccion} 
                    onChange = {handleChangeFormCliente}
                    error = {errorsClienteFeles?.valorTransaccion}
                  />
              }
            </div>
            {
              // CASO CUOTAS
              formClienteFeles.tipoTransaccion == "02" &&
                <> 
                <div className="w-layout-hflex h-inputs mt-16">
                  <InputForm 
                    required
                    accept = ".pdf" 
                    containerClassname = 'file-input' 
                    inputClassname = 'text-field w-input upload_file_input' 
                    placeholder = 'Comprobante' 
                    label="Comprobante" 
                    type="file" 
                    name="documento"
                    error={errorsClienteFeles.documento} 
                    onChange={handleChangeFormCliente}
                  />
                  <InputForm 
                    required
                    keyNameText = 'nombre' 
                    keyNameValue = 'idbanco' 
                    name = 'idBanco' 
                    placeholder = 'Banco' 
                    label = 'Banco' 
                    type = 'select' 
                    options = {bancos}
                    value = {formClienteFeles.idBanco} 
                    error = {errorsClienteFeles.idBanco} 
                    onChange = {(e: any) => handleChangeFormCliente({target: {name: 'idBanco', value: e.value}})}
                  />
                </div>
                <div className="w-layout-hflex h-inputs mt-16">
                  <InputForm 
                      required
                      placeholder = 'No. Autorización' 
                      label="No. Autorización" 
                      type="text" 
                      name="numAutorizacion" 
                      value={formClienteFeles.numAutorizacion} 
                      error={errorsClienteFeles.numAutorizacion} 
                      onChange={handleChangeFormCliente}
                    />
                </div>
                </>
            }
          </div>
          <div style={{display:'flex', justifyContent: 'center', width: '100%', gap: '20px'}}>
            <button 
              disabled={validFormFeles}
              onClick={modal_button_cerrarClienteFeles} 
              style={{display:'flex', width: '100%'}} 
              className="button transparent"
            >
              Cerrar
            </button>
          </div>
        </BasicCardDocumentos>
      </ModalBase>
    )
}